import {
  getUserAuth,
  getUserMenus,
  loginByUsername,
  logout,
  getUserInfo,
  getVerifyCodeUrl,
  getPubKey,
  needCheck,
  otpCodeSend,
  otpCode
} from '@/api/login'
import { setLoginCode, setLongitude, setLatitude, getToken, setFileDomain, setIsAdmin, setEstateName, setLevelId, setEstateId, setOcxVersion, setSysPwd, setCardPwdType, setUsedSystem, setCardBlock, setToken, removeToken, setCookiePubKey, removeCookiePubKey } from '@/utils/auth'
import { getJsonTree } from '@/api/base/menu' 
import constant from '@/utils/constant'
import { fetchList as brandList } from '@/api/base/devicebrand'
const user = {
  state: {
    auth: 0, // 是否认证
    user: '',
    status: '',
    code: '',
    token: getToken(),
    name: '',
    avatar: '/static/images/ren.png',
    introduction: '',
    roles: [],
    pubkey: '',
    setting: {
      articlePlatform: []
    },
    userRemoteMenuIds: [],
    router: [],
    websocketLogin: 0,
    brands: [],
  },

  mutations: {
    SET_WEBSOCKET_LOGIN(state, login) {
      state.websocketLogin = login;
    },
    SET_PUBKEY: (state, pubkey) => {
      state.pubkey = pubkey
    },
    SET_USER_ROUTER: (state, menus) => {
      if (menus == null || menus.length === 0) {
        return false;
      }
      menus.sort((x, y) => {
        return (x.parent_key > y.parent_key) ? 1 : -1
      })
      let tree = getJsonTree(menus, menus[0].parent_key);
      state.router = tree
    },
    SET_USER_AUTH: (state, auth) => {
      state.auth = auth
    },
    SET_USER_REMOTE_MENU_IDS: (state, menus) => {
      let setUserMenuIds = [];
      if (typeof menus === 'object') {
        menus.forEach((obj, index) => {
          // if (setUserMenuIds.indexOf(obj.id) === -1) {
          //   setUserMenuIds.push(obj.id);
          // }
          if (setUserMenuIds.indexOf(obj.id) === -1) {
            setUserMenuIds.push(parseInt(obj.id));
          }
        })
      }
      state.userRemoteMenuIds = setUserMenuIds
    },
    SET_BRANDS: (state, brands) => { 
      state.brands = brands
    },
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },

    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    GetUserAuth({ commit }) {
      return new Promise(async (resolve, reject) => {
        await getUserAuth().then(response => { 
          if (!response.data) { // 由于mockjs 不支持自定义状态码只能这样hack
            // eslint-disable-next-line prefer-promise-reject-errors
            reject('error')
          }
          commit('SET_USER_AUTH', response.data.results.length === 0 ? 0 : 1)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetUserMenus({ commit }) {
      return new Promise(async (resolve, reject) => {
        await getUserMenus().then(response => { 
          if (!response.data) { // 由于mockjs 不支持自定义状态码只能这样hack
            // eslint-disable-next-line prefer-promise-reject-errors
            reject('error')
          }
          commit('SET_USER_REMOTE_MENU_IDS', response.data.data)
          commit('SET_USER_ROUTER', response.data.data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetBrands({commit}) {
      return new Promise(async (resolve, reject) => {
        await brandList({where: {}})
        .then(response => {
          commit('SET_BRANDS', response.data.data);
        }).catch(error => {
          reject(error)
        })
      })
    },
    SetWebSocketLogin({ commit }, login) { 
      commit('SET_WEBSOCKET_LOGIN', login) 
    },
    OtpCode({ commit }, gcode) {
      return new Promise((resolve, reject) => {
        otpCode(gcode).then(response => {
          if (!response.data) { // 由于mockjs 不支持自定义状态码只能这样hack
            // eslint-disable-next-line prefer-promise-reject-errors
            reject('error')
          }
          const data = response.data.data
          resolve(data.is_need_piccode)
        }).catch(error => {
          reject(error)
        })
      })
    },
    OtpCodeSend({ commit }, mode) {
      return new Promise((resolve, reject) => {
        otpCodeSend(mode).then(response => {
          if (!response.data) { // 由于mockjs 不支持自定义状态码只能这样hack
            // eslint-disable-next-line prefer-promise-reject-errors
            reject('error')
          }
          const data = response.data.data
          resolve(data.is_need_piccode)
        }).catch(error => {
          reject(error)
        })
      })
    },
    NeedCheck({ commit }, username) {
      return new Promise((resolve, reject) => {
        needCheck(username).then(response => {
          if (!response.data) { // 由于mockjs 不支持自定义状态码只能这样hack
            // eslint-disable-next-line prefer-promise-reject-errors
            reject('error')
          }
          const data = response.data.data
          resolve(data.need_check)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetPubKey({ commit }) {
      return new Promise((resolve, reject) => {
        getPubKey().then(response => {
          if (!response.data) { // 由于mockjs 不支持自定义状态码只能这样hack
            // eslint-disable-next-line prefer-promise-reject-errors
            reject('error')
          }
          const data = response.data.data
          commit('SET_PUBKEY', data.pubkey)
          setCookiePubKey(data.pubkey)
          resolve(data.pubkey)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetVerifyCodeUrl({ commit }, username) {
      return new Promise((resolve, reject) => {
        getVerifyCodeUrl(username).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 用户名登录
    LoginByUsername({ commit }, userInfo) { 
      const username = userInfo.username.trim()
      const verifycode = userInfo.verifycode.trim()
      return new Promise((resolve, reject) => {
        loginByUsername(username, userInfo.password, userInfo.pubkey, verifycode).then(response => {
          const mdata = response.data.data;
          const data = mdata.estate
          setLoginCode(username);
          setToken(mdata.auth_token);
          setUsedSystem(data.usedsystem); 
          setCardBlock(constant.SYSTEM_LIFT, data.liftblock);
          setCardBlock(constant.SYSTEM_DOOR, data.doorblock);
          setCardBlock(constant.SYSTEM_CHANNEL, data.channelblock); 
          setSysPwd(data.syspwd); 
          setCardPwdType(data.cardpwdtype);  
          setLongitude(data.longitude); 
          setLatitude(data.latitude);  
          setOcxVersion(data.ocxversion); 
          setEstateName(data.estatename); 
          setEstateId(data.id); 
          setLevelId(data.level); 
          setIsAdmin(mdata.superadmin ? 1 : 0); 
          setFileDomain(data.domain);
          commit('SET_TOKEN', mdata.auth_token); 
          commit('DEL_ALL_VISITED_VIEWS');
          commit('WS_LOGIN', mdata.auth_token);
          console.log(mdata)
          //  }
          resolve(0)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.token).then(response => {
          if (!response.data) { // 由于mockjs 不支持自定义状态码只能这样hack
            // eslint-disable-next-line prefer-promise-reject-errors
            reject('error')
          }
          const data = response.data.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_USER_REMOTE_MENU_IDS', [])
          commit('SET_PUBKEY', '')
          commit('SET_USER_AUTH', 0)
          commit('WS_LOGOUT', '');
          removeToken()
          removeCookiePubKey()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('WS_LOGOUT', '');
        removeToken()
        resolve()
      })
    },
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js